import React, { useState, useEffect, useRef } from "react";
import { AppSettingContext } from "@src/components/Application";
import { IRecipientsStepProps } from "../../../models/props/RecipientsStepProps";
import { IRecipientsStep } from "../../../models/RecipientsStep.model";
import { GiftCardSendTypeEnum } from "../../../models/enums/GiftCardSendTypeEnum";
import LabeledCheckbox from "../../atoms/LabeledCheckbox";

interface IRecipientsStepHowToSendProps {
    sendBy: GiftCardSendTypeEnum;
    handleSendByChange(sendBy: GiftCardSendTypeEnum): void;
}

const RecipientsStepHowToSend = (props: IRecipientsStepHowToSendProps) => {
    //Page translation
    const { labels } = React.useContext(AppSettingContext);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {

    }, []);

    if (error) throw error;
    return (
        <>
            <h5>{labels.get("GiftCard.App.Steps.Recepients.Fields.HowToSend")}</h5>

            <div className="grid-container">
                <div className="form-field">
                    <LabeledCheckbox id="recipients__email" cssClass=""
                        checked={props.sendBy == GiftCardSendTypeEnum.BY_EMAIL}
                        onChange={(checked: boolean) => props.handleSendByChange(GiftCardSendTypeEnum.BY_EMAIL)}
                        labelCssClass="label-fs"
                        lableTitle={labels.get("GiftCard.App.Steps.Recepients.Fields.HowToSend.ByEmail")}
                    />
                </div>

                <div className="form-field">
                    <LabeledCheckbox id="recipients__sms" cssClass=""
                        checked={props.sendBy == GiftCardSendTypeEnum.BY_SMS}
                        onChange={(checked: boolean) => props.handleSendByChange(GiftCardSendTypeEnum.BY_SMS)}
                        labelCssClass="label-fs"
                        lableTitle={labels.get("GiftCard.App.Steps.Recepients.Fields.HowToSend.BySMS")}
                    />
                </div>

                <div className="form-field">
                    <LabeledCheckbox id="recipients__download-pdf" cssClass=""
                        checked={props.sendBy == GiftCardSendTypeEnum.BY_PDF}
                        onChange={(checked: boolean) => props.handleSendByChange(GiftCardSendTypeEnum.BY_PDF)}
                        labelCssClass="label-fs"
                        lableTitle={labels.get("GiftCard.App.Steps.Recepients.Fields.HowToSend.ByPDF")}
                    />
                </div>
            </div>
        </>
    )
}

export default RecipientsStepHowToSend;